import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {HashRouter as Router} from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <App />
  </Router>
);
